var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_148",
    "data-name": "Group 148",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.998,
    height: 31.995,
    viewBox: "0 0 33.998 31.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4195",
    "data-name": "Rectangle 4195",
    width: 33.998,
    height: 31.995,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M14,18V3.168a1,1,0,0,0-.993-1.007.987.987,0,0,0-.122.007A14.99,14.99,0,0,0,.009,17.522,15.185,15.185,0,0,0,15.189,32a14.888,14.888,0,0,0,8.454-2.752.994.994,0,0,0,.2-1.39,1.108,1.108,0,0,0-.1-.115Z",
    fill: "#3f8598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M32,13.949A15.036,15.036,0,0,0,18.05,0,1.006,1.006,0,0,0,17,.964c0,.017,0,.033,0,.05V14.995H30.985A1,1,0,0,0,32,14.013c0-.021,0-.043,0-.064",
    fill: "#e8758c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M32.987,18H18.156l9.877,9.877a1,1,0,0,0,1.387.043,14.975,14.975,0,0,0,4.571-8.8,1,1,0,0,0-.877-1.109A1.014,1.014,0,0,0,32.991,18Z",
    fill: "#ffeba5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.6bef85180ad5f6135fc2f206d41db77b.svg";
export { ForwardRef as ReactComponent };